import {Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ScriptLoaderService} from "../../script-loader.service";
import { LocalStorageService } from 'src/app/local-storage.service';
import { WINDOW } from '../../window-providers';
import { LocationService } from '../../location.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { IntegrationCompletePayment } from '../+state/payment.actions';
import { Store } from '@ngrx/store';
import { ReferenceType } from '../../store/types/IntegrationPayment';

declare const Ryft: any;

@Component({
  selector: 'app-ryft',
  templateUrl: './ryft.component.html',
  styleUrls: ['./ryft.component.scss']
})
export class RyftComponent implements OnInit, OnDestroy {

  @ViewChild('ryftPaymentForm') vivaForm: ElementRef;
  paymentWidgetScriptId:string = 'ryft-payment-script';
  paymentWidgetScriptUrl: string = "https://embedded.ryftpay.com/v1/ryft.min.js";
  paymentDetails: any;
  Ryft: any;
  payButtonEnabled: boolean = false;
  loading: boolean = true;

  constructor(private scriptLoaderService: ScriptLoaderService, 
              private storageService: LocalStorageService,
              private locationService: LocationService,
              private toastr: ToastrService,
              private router: Router,
              private store: Store,
              @Inject(WINDOW) private window: Window) { }

  ngOnInit(): void {
    this.loadPaymentData();
    this.removeScriptForComponent();
    this.loadScriptForComponent();
  }

  ngOnDestroy(): void {
    // Remove the script and associated function when the component is destroyed
    this.removeScriptForComponent();
  }

  private loadScriptForComponent(): void {
    this.scriptLoaderService.loadScript(this.paymentWidgetScriptUrl, this.paymentWidgetScriptId)
    .then(() => {
      console.log('Script loaded for the component', this.paymentWidgetScriptUrl);
      this.Ryft = Ryft;
      setTimeout(() => this.initializeRyftPayment());
      this.loading = false;
    })
    .catch((error) => {
      console.error(`Error loading script:${this.paymentWidgetScriptUrl}`, error, );
    });
  }

  private loadPaymentData(): void {
    let paymentDetailJson = this.storageService.getSavedState('paymentPayDetails');
    if (!paymentDetailJson) {
      this.window.location.href = this.locationService.base_url("cart");
    }
    this.paymentDetails = JSON.parse(paymentDetailJson);
  }

  private initializeRyftPayment(): void {

    if (!this.Ryft) {
      console.log("Ryft component is not initialized successfully");
      return;
    }

    this.Ryft.init({
      publicKey: this.paymentDetails?.requestJSON?.paymentParams?.RYFT_PAYMENT_PUBLIC_KEY,
      clientSecret: this.paymentDetails?.requestJSON?.paymentParams?.RYFT_PAYMENT_SESSION_SECRET,
      accountId: this.paymentDetails?.requestJSON?.paymentParams?.RYFT_PAYMENT_ACCOUNT_ID,
      fieldCollection: {
        billingAddress: {
          display: "minimum",
          value: {
            lineOne: this.paymentDetails?.requestJSON?.paymentFormParams?.address,
            postalCode: this.paymentDetails?.requestJSON?.paymentFormParams?.postalCode,
            country: this.paymentDetails?.requestJSON?.paymentFormParams?.country,
            region: ""
          }
        }
      }
    });

    this.addEventhandlers();
  }


  private handlePaymentResult(paymentSession): void {
    if (
      paymentSession.status === "Approved" ||
      paymentSession.status === "Captured"
    ) {

      let paymentFormParams = this.paymentDetails?.requestJSON?.paymentFormParams || {};
      this.store.dispatch(new IntegrationCompletePayment(paymentFormParams?.storeId, 
        this.paymentDetails?.requestJSON?.paymentTransactionId, paymentSession));

      return;
    }
    if (paymentSession.lastError) {
      const userFacingError = this.Ryft.getUserFacingErrorMessage(paymentSession.lastError);
      this.toastr.error(userFacingError);
    }
  }

  submitPayment(): void {

    this.loading = true;
    this.Ryft.attemptPayment()
    .then((paymentSession) => {
      this.handlePaymentResult(paymentSession);
      this.loading = false;
    })
    .catch((error) => {
      this.toastr.error(error);
      this.loading = false;
    });
  }

  private addEventhandlers():void {

    this.Ryft.addEventHandler("walletPaymentSessionResult", e => {
      this.handlePaymentResult(e.paymentSession);
    });
    
    this.Ryft.addEventHandler("cardValidationChanged", e => {
      this.payButtonEnabled = e.isValid;
    });
  }

  private removeScriptForComponent(): void {
    // Remove the script element from the DOM
    this.scriptLoaderService.removeScriptById(this.paymentWidgetScriptId)
  }

  public getAmount(): string {
    return this.paymentDetails?.requestJSON?.paymentFormParams?.cartAmount || 0;
  }
}
